import { render, staticRenderFns } from "./ContractsListDashboard.vue?vue&type=template&id=134c8114&scoped=true&lang=pug&"
import script from "./ContractsListDashboard.vue?vue&type=script&lang=ts&"
export * from "./ContractsListDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ContractsListDashboard.vue?vue&type=style&index=0&id=134c8114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c8114",
  null
  
)

export default component.exports